import type { OrderAppMetadataInput } from '@/graphql/orderApp/api';

import { canSetCampaignCookie, getCampaignCookie } from './cookieManager';
import { normalizeUtmValue } from './utils';

/**
 * Build Saleor checkout metadata inputs for UTM attribution.
 *
 * The storefront writes these keys into Saleor checkout metadata:
 * - client.utm_source
 * - client.utm_medium
 * - client.utm_campaign
 *
 * The orders microservice reads these keys for conversion attribution.
 *
 * Rules:
 * - Always returns all 3 keys
 * - Empty strings when cookie absent or consent gating denies usage
 * - Truncates values to 255 chars (CPI requirement)
 */
export const getCheckoutUtmMetadataInput = (
  countryCode: string,
): OrderAppMetadataInput[] => {
  const empty = {
    utm_source: '',
    utm_medium: '',
    utm_campaign: '',
  };

  const canSet = canSetCampaignCookie(countryCode);
  const cookie = canSet ? getCampaignCookie() : null;
  const data = cookie ?? empty;

  const metadata = [
    {
      key: 'client.utm_source',
      value: normalizeUtmValue(data.utm_source ?? ''),
    },
    {
      key: 'client.utm_medium',
      value: normalizeUtmValue(data.utm_medium ?? ''),
    },
    {
      key: 'client.utm_campaign',
      value: normalizeUtmValue(data.utm_campaign ?? ''),
    },
  ];

  return metadata;
};
